<template>
<p>{{ vulnerableDescription }}</p>  
</template>
<script>
export default {
  props: {
    vulnerable: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String
    }
  },

  computed: {
    vulnerableDescription() {
      switch(this.type) {
        case 'vulnerability': return this.vulnerable.description
        case 'cwe': return this.vulnerable.description
      }
    }
  }
}
</script>